import { FC, ReactNode } from 'react';
import { Providers } from './components/app/Providers';
import { App } from './components/app/App';

type ReactAppProps = {
  LDProvider: FC<{ children: ReactNode }>;
};

export const ReactApp = ({ LDProvider }: ReactAppProps) => {
  return (
    <Providers LDProvider={LDProvider}>
      <App />
    </Providers>
  );
};
